<!-- 连线游戏 -->
<template>
  <el-form ref="ref_form" :model="interferenceForm" :rules="rules" label-width="100px">
    <el-form-item label="学习单词数">
      {{ gameList.size }} 个
    </el-form-item>
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="setGame6-bar">
      <el-form-item :label="'页面' + (index + 1)" :prop="'dataList.' + index + '.num'" :rules="rules.num">
        <el-select v-model="item.num" placeholder="请选择" style="width: 200px;">
          <el-option label="2" :value="2" />
          <el-option label="3" :value="3" />
          <el-option label="4" :value="4" />
        </el-select>
      </el-form-item>
      <div class="right-bar">
        <el-button v-if="isShowAdd(index)" type="success" @click="addCard(index)">添加</el-button>
        <el-button v-if="interferenceForm.dataList.length > 1" type="warning" @click="deleteCard(index)">删除</el-button>
        <!-- <i v-if="interferenceForm.dataList.length > 1" class="el-icon-remove" @click="deleteCard(index)" />
        <i v-if="isShowAdd(index)" class="el-icon-circle-plus" @click="addCard(index)" /> -->
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
// import themeUploadList from '../../components/themeUploadList'
// import uploadList from '@/components/Upload/uploadList.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { saveConfGraphicConnection } from '@api/courseManagement/api_quiz'
export default {
  components: {
    // themeUploadList
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: [Array, Object],
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        dataList: [
          { num: 2 }
        ]
      },
      rules: {
        num: [{ required: true, message: '请选择', trigger: 'change' }]
      }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      if (this.gameList.nums.length > 0) {
        for (const item of this.gameList.nums) {
          this.interferenceForm.dataList.push({ num: item })
        }
      } else {
        this.interferenceForm.dataList = [{ num: 2 }]
      }
    }
  },

  created () {

  },
  methods: {
    getOptions () {

      // getDictoryInfoByCode ('').then(res => {  })
    },

    isShowAdd (index) {
      return (this.interferenceForm.dataList.length - 1) === index && this.interferenceForm.dataList.length <= 10
    },
    addCard (index) {
      this.interferenceForm.dataList.push({ num: 2 })
    },
    deleteCard (index) {
      this.interferenceForm.dataList.splice(index, 1)
    },
    // 保存游戏配置项
    saveGameOptions() {
      let total = 0
      for (const item of this.interferenceForm.dataList) {
        total = total + item.num
      }
      if (total !== this.gameList.size) {
        this.$message.error('页面配置个数与学习单词个数不一致')
        return false
      }
      const nums = this.interferenceForm.dataList.map(item => {
        return item.num
      })
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        quizType: this.currentQuizType,
        nums
      }

      saveConfGraphicConnection(params).then(res => {
        this.$message.success('操作成功')
        this.$emit('finishSave')
      })
    }
  }
}
</script>

<style lang='scss'>
  .setGame6-bar{
    display: flex;
    /*align-items: center;*/
    .right-bar{
      margin-left: 30px;
      /*margin-top: 2px;*/
      i{
        padding: 5px;
        cursor: pointer;
        font-size: 26px;
        color: #79C251;
      }
      i+i{
        margin-left: 20px;
      }
    }
  }

</style>
